import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import { ManageService } from "../services/Services";
import useStore from "../services/store/useStore";

export const useGetEstimateAmount = platform => {
    const { amountUsd } = useStore(state => state.receiveData);

    const [isLoading, setIsLoading] = useState(false);
    const [costs, setCosts] = useState({
        cost: "",
        amountToReceive: 0,
    });

    const getEstimateCost = useCallback(async () => {
        try {
            setIsLoading(true);
            const estimateCosts = await ManageService.getEstimateCost(platform, amountUsd);
            console.log("estimateCosts hook", estimateCosts);

            const comissionRate = estimateCosts.commissionRate || 0; //comissionRate es el porcentaje de la comision
            const totalCost = estimateCosts.totalCost || 0; //totalCost es el monto en usd del impuesto
            const totalComissions = estimateCosts?.totalCom || 0; //totalCom es el comissionRate expresado en usd con relacion al monto a pagar
            const totalDiscounts = totalCost + totalComissions; //total de comision e impuestos a pagar

            const COMISIONES_TEXT = `${comissionRate}% + $${totalCost}`;

            const amountWithoutComissions = amountUsd - totalDiscounts;

            setCosts({ cost: COMISIONES_TEXT, amountToReceive: amountWithoutComissions });
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    }, [amountUsd, platform]);

    useEffect(() => {
        getEstimateCost();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { isLoading, costs };
};
